import { Application } from "pixi.js";
import { Fish } from "./fish";

export const player = (
  app: Application,
  fish: Fish,
  bubble: (x: number, y: number) => Promise<void>,
): Fish => {
  let controllerActive = false;

  const blowBubble = () => {
    const x = Math.cos(fish.sprite.rotation) * (fish.sprite.width / 2);
    const y = Math.sin(fish.sprite.rotation) * (fish.sprite.width / 2);
    bubble(fish.sprite.x + x, fish.sprite.y + y);
  };

  window.onkeyup = (e) => {
    switch (e.key) {
      case "ArrowUp":
      case "w":
      case "ArrowDown":
      case "s":
        fish.dy = 0;
        break;
      case "ArrowLeft":
      case "a":
      case "ArrowRight":
      case "d":
        fish.dx = 0;
        fish.dx = 0;
        break;
      case " ":
        blowBubble();
    }
  };

  window.onkeydown = (e) => {
    switch (e.key) {
      case "ArrowUp":
      case "w":
        fish.dy = 1;
        break;
      case "ArrowDown":
      case "s":
        fish.dy = -1;
        break;
      case "ArrowLeft":
      case "a":
        fish.dx = 1;
        break;
      case "ArrowRight":
      case "d":
        fish.dx = -1;
        break;
    }
  };

  const touchMove = (e: TouchEvent) => {
    let x = 0;
    let y = 0;
    for (const touch of e.touches) {
      x += touch.pageX;
      y += touch.pageY;
    }
    x = x / e.touches.length;
    y = y / e.touches.length;

    fish.dx = fish.sprite.x - x;
    fish.dy = fish.sprite.y - y;
  };

  const touchStop = () => {
    fish.dx = 0;
    fish.dy = 0;
  };

  let latestTap: number;
  window.ontouchstart = (e) => {
    const now = new Date().getTime();
    const timesince = now - latestTap;
    if (timesince < 600 && timesince > 0) {
      blowBubble();
    }
    latestTap = now;
    touchMove(e);
  };
  window.ontouchmove = touchMove;
  window.ontouchend = touchStop;
  window.ontouchcancel = touchStop;

  app.ticker.add(() => {
    navigator.getGamepads().forEach((pad) => {
      if (pad) {
        if (pad.axes[0] === 0 && pad.axes[1] === 0) {
          if (controllerActive) {
            fish.dx = 0;
            fish.dy = 0;
          }
          controllerActive = false;
        } else {
          fish.dx = -pad.axes[0];
          fish.dy = -pad.axes[1];
          controllerActive = true;
        }
        if (pad.buttons[0].pressed) {
          blowBubble();
        }
      }
    });
  });

  return fish;
};
